import z from "zod";

/**
 * ArquivoDiversoSchema
 */

export const ArquivoDiversoSchema = z.object({
  descricao: z.string({ required_error: 'Este campo deve ser preenchido!', invalid_type_error: 'Este campo deve ser preenchido!' }).nonempty('Este campo deve ser preenchido!'),
  arquivo: z.instanceof(File).nullable().default(null),
  limparArquivo: z.boolean().default(false),
});

/**
 * ArquivoDiversoForm
 */

export type ArquivoDiversoForm = z.infer<typeof ArquivoDiversoSchema>;